import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import PhoneField from '../../custom/PhoneField';
import MailField from '../../custom/MailField';
import Adresse from './Adresse';

import '../EditionPage.css';

class Professionnel extends Component {

    constructor(props){
        super(props)
        this.state = {
            nom: this.props.professionnel.nom,
            typeStructure: this.props.professionnel.typeStructure,
            obs: this.props.professionnel.obs,
        };
    }

    handleChange = (champ)  => event => {
        this.props.professionnel[champ]=event.target.value;
        this.setState({
            [champ]: event.target.value,
        });
    }

    render(){
        return (
        <div className='professionnel'>        
            <TextField name='typeStructure' label='Type de structure' className="fullWithInput" value={this.state.typeStructure} onChange={this.handleChange("typeStructure")} />
            <TextField name='nom' label='Nom' className="fullWithInput" value={this.state.nom} onChange={this.handleChange("nom")} />
                <div className="inlineInputs">
                <PhoneField id='telephone1' label='T&eacute;l&eacute;phone 1' className="telephone" value={this.props.professionnel.telephone1} onChange={this.handleChange("telephone1")} />
                <PhoneField id='telephone2' label='T&eacute;l&eacute;phone 2' className="telephone" value={this.props.professionnel.telephone2} onChange={this.handleChange("telephone2")} />
            </div>
            <div className="fullWith">
                <MailField id='mail' label='Adresse mail' value={this.props.professionnel.mail} onChange={this.handleChange("mail")} />
            </div>
            <TextField name='obs' label='Observations' multiline={true} fullWidth={true} className="obs" value={this.state.obs} onChange={this.handleChange("obs")} />
            <Adresse adresse={this.props.professionnel.adresse} />
        </div>);
    }
}

Professionnel.propTypes= {
    professionnel: PropTypes.object.isRequired,
}

export default Professionnel;


// WEBPACK FOOTER //
// ./src/components/content/client/Professionnel.js